import { IPagination } from '~/models/Common';
import { ICoupon } from '~/models/Coupon';

export const couponsMock: IPagination<ICoupon[]> = {
  total: '0',
  page: 1,
  perPage: 8,
  lastPage: 0,
  data: [
    {
      id: '1',
      code: 'CUPOM1',
      type: 'Fixo',
      value: 'R$10,00',
      validity: '20/12/2020',
    },
    {
      id: '2',
      code: 'CUPOM1',
      type: 'Fixo',
      value: 'R$10,00',
      validity: '20/12/2020',
    },
    {
      id: '3',
      code: 'CUPOM1',
      type: 'Fixo',
      value: 'R$10,00',
      validity: '20/12/2020',
    },
    {
      id: '4',
      code: 'CUPOM1',
      type: 'Fixo',
      value: 'R$10,00',
      validity: '20/12/2020',
    },
    {
      id: '5',
      code: 'CUPOM1',
      type: 'Fixo',
      value: 'R$10,00',
      validity: '20/12/2020',
    },
    {
      id: '6',
      code: 'CUPOM1',
      type: 'Fixo',
      value: 'R$10,00',
      validity: '20/12/2020',
    },
  ],
};
